import { EntityMetadataMap } from '@ngrx/data';
import {
  pluralNamesGenerator,
  metaDataGenerator,
  defAdditionalCollectionState,
} from './entity-metadata.utils';
import { APP_ENTITIES } from './app-entities';

const entityMetadata: EntityMetadataMap = {
  ...metaDataGenerator(APP_ENTITIES),
  question: {
    sortComparer: (a: { rank: number }, b: { rank: number }) => a.rank - b.rank,
    additionalCollectionState: defAdditionalCollectionState,
  },
};
const pluralNames = pluralNamesGenerator(APP_ENTITIES);

export const entityConfig = {
  entityMetadata,
  pluralNames,
};
